<template>
<div >






<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>



<div class="mt-4" v-if="!loading" style="min-height:450px">

<template v-if="$store.state.audit_schedules.audit_schedule.status=='exempt'">
  
<div class="grid">


<div class="col-8"><h4 class="text-green-500 mt-2">{{$store.state.languages.lang_phrases.bu_tedarikci_denetlemenin_bu_asamasindan_muaf_olarak_isaretlenmis}} <i class="pi pi-check ml-2" style="font-size: 1.2em"></i></h4>
</div>

<div class="col-4">
<div class="flex align-items-center justify-content-end">
<Button label="Denetleme Aşamasından Muafiyeti Kaldır" class=" p-button-danger p-button-outlined  p-button-sm mr-2" icon="pi pi-exclamation-circle"  :loading="submitting" @click="markAsUnexempt" ></Button>
</div>
</div>


</div>

</template>


<!-- schedule views-->
<template v-else>
<div class="grid">


<div class="col-12" >
<div class="flex align-items-center justify-content-end" >

<template v-if="show_exempt_area">
  <InputText  type="number" v-model="audit_result_points"  class="p-inputtext-sm mb-0 mr-2" :class="{'p-invalid':missing_points_error }" placeholder="Bölüm puanı"/>
<Button  class=" p-button-primary p-button-outlined  p-button-sm mr-2" icon="pi pi-check"  :loading="submitting" @click="markAsExempt" ></Button>
<Button  class=" p-button-danger p-button-outlined  p-button-sm " icon="pi pi-times"  :loading="submitting" @click="hideExemptArea" ></Button>
</template>

<template v-else>
  <Button :label="$store.state.languages.lang_phrases.muaf_olarak_isaretle" class=" p-button-primary p-button-outlined  p-button-sm mr-2" icon="pi pi-check"  :loading="submitting" @click="showExemptArea" ></Button>
</template>



</div>
</div>




<div class="col-6">

<ClickEditSelect :title="$store.state.languages.lang_phrases.denetci" :value="selected_auditor" :options="auditors" valkey="type" @dataChanged="auditorSelected" :filter="true" emptymessage="Bu görüşmede kullanılan soru listesine henüz denetçi atanmamış" />


<template v-if="selected_date">
<div class="grid">

<div class="col-3 md:col-2">
<p class="click_edit_value_title">{{$store.state.languages.lang_phrases.oturum_tarihi}}:</p>
</div>

<div class="col-9 md:col-10">
<p class="click_edit_value animate_class">
{{ $filters.momentFormat( selected_date," Do-MM-YYYY dddd")}}
</p>
</div>

</div>

<div class="grid pl-2">
<div class="field col-6 ">
<label for="starttime">Başlama Saati</label>
<Calendar inputId="starttime"  v-model="selected_start_time" :timeOnly="true" :stepMinute="15" :touchUI="false" :modelValue="selected_start_time" class="p-inputtext-sm w-full" @date-select="startTimeUpdated"/>
</div>

<div class="field col-6 ">
<label for="endtime">Bitiş Saati</label>
<Calendar inputId="endtime"  v-model="selected_end_time" :timeOnly="true" :stepMinute="15" :touchUI="false" :modelValue="selected_end_time" class="p-inputtext-sm w-full" />
</div>
</div>

<ClickEditInputText  :title="$store.state.languages.lang_phrases.video_konferans_linki" :value="selected_video_link" valkey="videocall_link" @dataChanged="videoLinkEntered"></ClickEditInputText>

<ClickEditInputTextArea  :title="$store.state.languages.lang_phrases.denetciye_not" :value="note_to_auditor" valkey="note_to_auditor" @dataChanged="auditorNoteEntered"></ClickEditInputTextArea>


<div class="flex justify-content-end flex-wrap mt-3" v-if="selected_auditor && selected_date && selected_start_time" >
 <Button :label="$store.state.languages.lang_phrases.kaydet" class=" p-button-primary p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" @click="submit"></Button>
</div>



</template>



</div>






<div class="col-6" v-if="selected_auditor">
<FullCalendar  :options="options" />
</div>



</div>
</template>
<!-- schedule views-->









</div>

<ScheduleDetailsModal></ScheduleDetailsModal>

</div>
</template>

<script>
import '@fullcalendar/core';
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import trLocale from '@fullcalendar/core/locales/tr';
import enLocale from '@fullcalendar/core/locales/en-gb';
import moment from "moment"
export default {

  name: 'FlowConditions',

  data () {
    return {
    	options: {
        plugins:[dayGridPlugin, timeGridPlugin, interactionPlugin],
        initialDate : null,
        contentHeight:600,
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay'
        },
        editable: false,
        selectable:true, 
        selectMirror: true, 
        dayMaxEvents: true,
        locale:trLocale,
        dateClick: this.handleDateClick,
        eventClick: this.hadleEventClick,
        events: [],
      },
      supplierverifications:[],
    	loading:true,
      submitting:false,
      item:null,
      auditors:[],
      selected_auditor:null,
      selected_date:null,
      selected_start_time:null,
      selected_end_time:null,
      selected_video_link:null,
      note_to_auditor:null,
      ready_to_submit:false,
      audit_result_points:null,
      missing_points_error:false,
      show_exempt_area:false
    }
  },
  components: {
    FullCalendar // make the <FullCalendar> tag available
  },
  computed:{
    userlang()
    {
      return this.$store.state.auth.user.preflang_id
    }
  },
  watch:{
    userlang(newval)
    {
      if(newval==3)
      {
        this.options.locale = trLocale
      }
      if(newval==15)
      {
        this.options.locale = enLocale
      }
    }
  },
  mounted()
  {    
    this.getData()
  },
  methods:{
    showExemptArea()
    {
      this.show_exempt_area = true
    },
    hideExemptArea()
    {
      this.show_exempt_area = false
    },
    markAsExempt()
    {
      if(!this.audit_result_points)
      {
        this.missing_points_error = true
        return false
      }
      this.submitMarkAsExempt()
    },
    submitMarkAsExempt()
    {
      this.submitting = true
      let formdata = new FormData()  
      formdata.append("points",this.audit_result_points)   
      this.generalSubmission(formdata,"audit_schedule/mark_as_exempt/"+this.$store.state.audit_schedules.audit_schedule.id,this.aftermarkAsExemptChange)
    },
    
    markAsUnexempt()
    {
      this.submitting = true
      let formdata = new FormData()     
      this.generalSubmission(formdata,"audit_schedule/mark_as_unexempt/"+this.$store.state.audit_schedules.audit_schedule.id,this.aftermarkAsExemptChange)
    },
    aftermarkAsExemptChange(response)
    {
      console.log(response.data)
      this.submitting = false
      this.show_exempt_area = false
      this.$store.dispatch('audit_schedules/setAuditSchedule',response.data)
      if(response.data.auditresult)
       {
        this.audit_result_points =  response.data.auditresult.points
       }
    },
    createEventObj(date,hours)
    {
      console.log(this.item)
      let events = this.sanitizeArray(this.options.events)
      events = events.filter((item)=>{return item.id !== this.item.id})
      this.options.events = events
      let event =  {
        id: this.item.id,
        title: this.item.supplier.name,
        start: date+" "+hours,
      }
      this.options.events.push(event)
    },
    async auditorSelected(data)
    {
      console.log(data)
      this.options.events = []
      let selected_auditor = this.auditors.find((item)=>{return item.id == data.value})
      this.selected_auditor = selected_auditor
      console.log(selected_auditor)
      await this.getAuditorVerificationSchedule()
    },
    videoLinkEntered(data)
    {
      this.selected_video_link = data.value
      this.ready_to_submit = true
    },
    auditorNoteEntered(data)
    {
      this.note_to_auditor = data.value      
    },
    hadleEventClick(data)
    {
      console.log(data)  
      this.$store.dispatch('audit_schedules/setSelectedEvent',data.event._def.publicId) 
      this.$store.dispatch('audit_schedules/setShowDetailModal',true) 
    },
    handleDateClick(data)
    {
      console.log(this.$store.state.audit_schedules.audit_schedule)
      let duration = this.$store.state.audit_schedules.audit_schedule.flowsupplier.flow.auditsettings.duration
      this.selected_date = data.date
      let start = moment(data.dateStr+" 08:00","Do-MM-YYYY HH:mm")
      let end = moment(data.dateStr+" 08:00","Do-MM-YYYY HH:mm").add(duration,"hours")
      this.createEventObj(data.dateStr,"08:00")
      console.log("datte") 
      console.log(start)   
      console.log(end)      
      this.selected_start_time = start.toDate()
      this.selected_end_time = end.toDate()


    },
    submit()
    {
      console.log(this.selected_start_time)
      console.log(this.selected_date)
      console.log(moment(this.selected_start_time).format("HH:mm"))
      //return false
      let formdata = new FormData()
      formdata.append("auditor_id",this.selected_auditor.auditor.id)
      formdata.append("date",moment(this.selected_date).format("YYYY-MM-DD"))
      formdata.append("start",moment(this.selected_start_time).format("HH:mm"))
      formdata.append("videocall_link",this.selected_video_link)
      formdata.append("note_to_auditor",this.note_to_auditor)
      this.generalSubmission(formdata,"audit_schedule/set_audit_data/"+this.$route.params.id,this.afterSubmit)
    },
    async afterSubmit(response)
    {
      console.log(response.data)
      let item = await this.generalApiGetWithoutLoader("audit_schedule/"+this.$route.params.id)
      item = await this.parseVerificationData(item)
      this.item = await item
      this.$store.dispatch('audit_schedules/setAuditSchedule',this.item) 
    },
    startTimeUpdated(event)
    {
      let duration = this.$store.state.audit_schedules.audit_schedule.flowsupplier.flow.auditsettings.duration
      console.log(event)
      console.log(this.selected_start_time)
      let end = moment(this.selected_start_time,"Do-MM-YYYY HH:mm").add(duration,"hours")
      this.selected_end_time = end.toDate()
    },
    async parseVerificationData(item)
    {
      let duration = this.$store.state.audit_schedules.audit_schedule.flowsupplier.flow.auditsettings.duration
      
      
      if(item.auditor)
      {        
        let selected_auditor = this.auditors.find((element)=>{return element.auditor_id == item.auditor.id})
        this.selected_auditor = selected_auditor
      }
      if(item.schedule_date)
      {
        this.selected_date = item.schedule_date
      }

      if(item.schedule_time)
      {
        let start = moment(item.schedule_date+" "+item.schedule_time,"Do-MM-YYYY HH:mm")
        this.selected_start_time = start.toDate()
        //this.selected_end_time = item.schedule_time.add(duration,"hours")
        let end = moment(item.schedule_date+" "+item.schedule_time,"Do-MM-YYYY HH:mm").add(duration,"hours")        
        console.log(end)
        this.selected_end_time = end.toDate()
      }
      if(item.videocall_link)
      {
        this.selected_video_link = item.videocall_link
      }
      if(item.note_to_auditor)
      {
        this.note_to_auditor = item.note_to_auditor
      }
      if(item.auditor && item.schedule_date && item.schedule_time)
      {
        this.item = item
        this.createEventObj(item.schedule_date,item.schedule_time)
        this.options.initialDate = item.scheduled_at
      }
      

      return item
    },
    async getAuditorVerificationSchedule()
    {
      
      let events
      //events = await this.generalApiGetWithoutLoader("verification/auditor_verification_schedule/"+this.selected_auditor.auditor_id+"/"+this.item.flowsupplier_id)
      events = await this.generalApiGetWithoutLoader("verification/auditor_all_schedule/"+this.selected_auditor.auditor_id)
      
      console.log(events)
      for(let event of events)
      {
        
        if(event.flowsupplier)
        {
          let flowsupplier = event.flowsupplier
          if(event.preaudit)
          {
            let preaudit = event.preaudit
            if(preaudit.id !==this.item.id)
            {
              console.log("audit")
              let new_event =  {
                id: preaudit.id,
                title: flowsupplier.supplier.name,
                start: preaudit.schedule_date+" "+preaudit.schedule_time,
                color:"#a82400"
              }
              this.options.events.push(new_event)
            }
          }

          if(event.verification)
          {
            console.log("verification")
            //console.log(flowsupplier.supplier)
            let verification = event.verification
            
              let new_event =  {
                id: verification.id,
                title: flowsupplier.supplier.name,
                start: verification.schedule_date+" "+verification.schedule_time,
                color:"#a82400"
              }
              this.options.events.push(new_event)            
          }

          if(event.audit)
          {
            console.log("audit")
            let audit = event.audit
            
              let new_event =  {
                id: audit.id,
                title: flowsupplier.supplier.name,
                start: audit.schedule_date+" "+audit.schedule_time,
                color:"#a82400"
              }
              this.options.events.push(new_event)            
          }

          
        
        }
        

        
          
        
      }
      //loop

    },
    
  	async getData()
    {
       let item = await this.generalApiGetWithoutLoader("audit_schedule/"+this.$route.params.id)
       let auditors = await this.generalApiGetWithoutLoader("verification/questionlist_auditors/"+item.flowsupplier.flow.questionlist_id)
       let supplierverifications = await this.generalApiGetWithoutLoader("audit_schedule/supplier_audits/"+item.supplier_id)
       await console.log("supplierverifications")
       await console.log(auditors)
       await console.log(item)
       for(let item of auditors)
       {
        item.name = item.auditor.user.name + " - "+item.auditor_points+" "+this.$store.state.languages.lang_phrases.puan        
       }
       this.auditors = await auditors

       
       await console.log(item)
       if(item.auditresult)
       {
        this.audit_result_points = await item.auditresult.points
       }
       item = await this.parseVerificationData(item)
       this.item = await item
       if(this.item.auditor)
       {
          await this.getAuditorVerificationSchedule()
       }
       

       this.$store.dispatch('audit_schedules/setAuditSchedule',this.item) 
       this.loading = await false

    },   
  }
};
</script>

<style lang="css" scoped>
</style>